import { Component } from '@angular/core';

@Component({
	templateUrl: 'errorResponse.component.html',
	standalone: false,
})
export class ErrorResponseComponent {
	constructor() { }
}
